import buildConfig from 'utils/buildConfig';

export const useFeatureFlags = () => {
  return {
    isSingSaverAuthEnabled: buildConfig.features?.enableSingSaverAuth || false,
  };
};

export default useFeatureFlags;
